import intl from "react-intl-universal";
import { TbAlertTriangle, TbX } from "react-icons/tb";

export const BaasEntidadesAlertBanner = ({
  pendingKybCount,
  pendingCount,
  exceededTargets,
  dismissed,
  onDismiss,
  onViewPending,
  onViewPendingKyb,
}) => {
  if (dismissed) {
    return null;
  }

  const hasPendingKyb = pendingKybCount > 0;
  const hasExceeded = exceededTargets.length > 0;
  const hasPending = pendingCount > 0;

  if (!hasPendingKyb && !hasExceeded && !hasPending) {
    return null;
  }

  const severity = hasExceeded ? "warning" : "info";
  const containerClass =
    severity === "warning"
      ? "border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900/50 dark:bg-amber-950/30 dark:text-amber-200"
      : "border-blue-200 bg-blue-50 text-blue-900 dark:border-blue-900/50 dark:bg-blue-950/30 dark:text-blue-200";

  const messages = [];

  if (hasPendingKyb) {
    messages.push(
      intl.get("baas.entidades.alert.pendingKyb", { count: pendingKybCount }),
    );
  }

  if (hasExceeded) {
    messages.push(intl.get("baas.entidades.alert.exceededTargets"));
  } else if (hasPending) {
    messages.push(intl.get("baas.entidades.alert.pendingReview", { count: pendingCount }));
  }

  return (
    <div
      className={`flex flex-col gap-3 rounded-xl border px-4 py-3 sm:flex-row sm:items-center sm:justify-between ${containerClass}`}
      role="status"
    >
      <div className="flex min-w-0 items-start gap-3">
        <TbAlertTriangle className="mt-0.5 h-5 w-5 shrink-0" aria-hidden />
        <div className="min-w-0 space-y-1">
          <p className="text-sm font-semibold">{intl.get("baas.entidades.alert.title")}</p>
          {messages.map((message) => (
            <p key={message} className="text-sm opacity-90">
              {message}
            </p>
          ))}
        </div>
      </div>

      <div className="flex shrink-0 flex-wrap items-center gap-2">
        {hasPendingKyb ? (
          <button
            type="button"
            className="extract-filter-panel__btn extract-filter-panel__btn--primary !h-8 !px-3 !text-xs"
            onClick={onViewPendingKyb}
          >
            {intl.get("baas.entidades.alert.viewPendingKyb")}
          </button>
        ) : null}
        {hasPending ? (
          <button
            type="button"
            className="extract-filter-panel__btn !h-8 !px-3 !text-xs"
            onClick={onViewPending}
          >
            {intl.get("baas.entidades.alert.viewPending")}
          </button>
        ) : null}
        <button
          type="button"
          className="inline-flex h-8 w-8 items-center justify-center rounded-lg transition hover:bg-black/5 dark:hover:bg-white/10"
          onClick={onDismiss}
          aria-label={intl.get("words.close")}
        >
          <TbX size={16} aria-hidden />
        </button>
      </div>
    </div>
  );
};
